export default {
    name: "notFound"
}
